module.exports = __webpack_public_path__ + "static/media/webview-img2.2c31ab91.png";